import { jsx as _jsx } from "react/jsx-runtime";
import { TransactionsCollection, } from "@bundles/UIAppBundle/collections";
import { Routes } from "@bundles/UIAppBundle";
import { EditOutlined, EyeOutlined, UnorderedListOutlined, } from "@ant-design/icons";
import { AntTableSmart } from "@bluelibs/x-ui-admin";
import { features } from "../../config/features";
import { ReadyForPaymentTransactionList } from "../../config/ReadyForPaymentTransactionList";
export class ReadyForPaymentListAntTableSmart extends AntTableSmart {
    constructor() {
        super(...arguments);
        this.collectionClass = TransactionsCollection;
    }
    setRoles(roles) {
        this.roles = roles;
    }
    getBody() {
        return ReadyForPaymentTransactionList.getRequestBody();
    }
    getColumns() {
        const list = this.container.get(ReadyForPaymentTransactionList);
        list.setRoles(this.roles);
        list.build();
        return [...list.rest(), this.getActionsColumn()];
    }
    getActionsColumn() {
        return {
            title: this.i18n.t("generics.list_actions"),
            key: "actions",
            fixed: "right",
            width: 100,
            render: (_, model) => {
                return this.generateActions(model, {
                    label: undefined,
                    icon: _jsx(UnorderedListOutlined, {}, void 0),
                    items: this.getActionItems(),
                });
            },
        };
    }
    getSortMap() {
        return ReadyForPaymentTransactionList.getSortMap();
    }
    getActionItems() {
        const actions = [];
        if (features.view) {
            actions.push({
                label: this.i18n.t("generics.view"),
                icon: _jsx(EyeOutlined, {}, void 0),
                action: (model) => {
                    this.router.go(Routes.TRANSACTIONS_VIEW, {
                        params: { id: model._id.toString() },
                    });
                },
            });
        }
        if (features.edit) {
            actions.push({
                label: this.i18n.t("generics.edit"),
                icon: _jsx(EditOutlined, {}, void 0),
                action: (model) => {
                    this.router.go(Routes.TRANSACTIONS_EDIT, {
                        params: { id: model._id.toString() },
                    });
                },
            });
        }
        // if (features.delete) {
        //   actions.push({
        //     label: this.i18n.t("generics.delete"),
        //     icon: <DeleteOutlined />,
        //     confirm: this.i18n.t("generics.ask_confirmation"),
        //     action: (model) => {
        //       this.collection.deleteOne(model._id).then(() => {
        //         this.load();
        //       });
        //     },
        //   });
        // }
        return actions;
    }
}
